export function generateClassNameBySidebarTreeNodeKey(key: string) {
  return `sidebar-tree-node-${key.replace(/[.]/g, '-')}`;
}
